module.exports = __webpack_public_path__ + "static/media/trees.6f6bf47b.png";